import { useEffect } from 'react'

import App from './App'
import './landing-tailwind.scoped.css'
import './landing-agencias.css'

const BODY_CLASS = 'hutrit-ag-landing-body'

/**
 * Landing de Hutrit para agencias.
 *
 * Los estilos provienen de `landing-tailwind.scoped.css`, el build de Tailwind
 * del proyecto original acotado a `.hutrit-ag-landing` para que el preflight y
 * las utilidades no choquen con el Bootstrap global de la app.
 */
const LandingAgencias = () => {
  useEffect(() => {
    document.body.classList.add(BODY_CLASS)
    return () => document.body.classList.remove(BODY_CLASS)
  }, [])

  return (
    <div className="hutrit-ag-landing antialiased selection:bg-[#00FF9D]/20 selection:text-[#00FF9D]">
      <App />
    </div>
  )
}

export default LandingAgencias
